import colors from './colors';
import devices from './devices';
export const NAMESPACE = 'detailChannel';

const customTheme = {
  colors,
  mediaQueries: {
    mobileS: `only screen and ${devices.mobileS}`,
    mobileM: `only screen and ${devices.mobileM}`,
    mobileL: `only screen and ${devices.mobileL}`,
    tablet: `only screen and ${devices.tablet}`,
    laptop: `only screen and ${devices.laptop}`,
    laptopL: `only screen and ${devices.laptopL}`,
    desktop: `only screen and ${devices.desktop}`,
    desktopL: `only screen and ${devices.desktopL}`,
    mobileIos: `only screen and (max-height: 740px) and ${devices.mobileM}`,
    mobileIosNotch: `only screen and (min-height: 812px) and ${devices.mobileM}`,
    // iPhone XR, 11, 12, 13
    mobileIosNotchMax: `only screen and (min-height: 896px) and ${devices.mobileL}`,
    // iPhone SE (3rd gen)
    mobileIosSE3: `only screen and (min-height: 667px) and ${devices.mobileM}`,
    // iPhone 14
    mobileIosNotch14: `only screen and (min-height: 927px) and ${devices.mobileL}`,
  },
};

export default customTheme;
